import React, { useContext } from "react";
import StateContext from "../../StateContext";
import CommonNavs from "./CommonNavs";
const HeaderNav = () => {
  const appState = useContext(StateContext);
  return <div>{appState.loggedIn ?   <CommonNavs.CommonNavsSignedIn /> : <CommonNavs.CommonNavsSignedOut />}</div>;
};

export default HeaderNav;
